import React from 'react';
import './index.css';
import HomePage from '../../pages/home';
// import AboutPage from '../../pages/about';

function App() {
  return <HomePage />
}

export default App;
